/* global tindie, ko, ga */

tindie.messaging = (function(t, $) {
    var aj = tindie.ajax;
    t.newMessageUrl = "/accounts/messages/new";
    t.lock = ko.observable(false);
    t.TindieMessage = function(appendPageName, pageName) {
        var self = this;
        self.username = ko.observable();
        self.displayName = ko.observable();
        self.subject = ko.observable().extend({
            required: {
                message: 'Please enter a subject.'
            }
        });
        self.message = ko.observable().extend({
            required: {
                message: 'Please enter a message.'
            }
        });
        self.prepareForm = function(data, event) {
            var button = $(event.currentTarget);
            self.displayName(button.data('display-name'));
            self.username(button.attr('data-user'));
            if (window.ga && ga.create) {
                ga('send', 'event', pageName, 'click', pageName);
            }
        };
        self.send = function(messageSuffix) {
            if (t.lock()) {
                return $.Deferred();
            }
            var username = self.username();
            username = username == null ? '' : String(username).trim();
            if (!username) {
                aj.notify_message({
                    message: 'The recipient could not be selected. Close this message and click the contact button again.',
                    extra_tags: 'error'
                });
                return $.Deferred();
            }
            var messageAppend = messageSuffix || "";
            if (appendPageName) {
                messageAppend = " [Sent from " + pageName + "]";
            }
            var data = {
                username: username,
                subject: self.subject().trim(),
                message: self.message().trim() + messageAppend,
            };
            t.lock(true);
            return $.ajax({
                type: 'POST',
                url: t.newMessageUrl,
                dataType: 'json',
                data: data
            }).done(function(result) {
                if (result.django_messages && result.django_messages.length) {
                    aj.show_notifications(result.django_messages);
                } else if (result.success !== true) {
                    aj.notify_message({
                        message: aj.errorMessage,
                        extra_tags: 'error'
                    });
                }
                if (result.success === true) {
                    $('#id-sendpm-modal').modal('hide');
                }
            }).fail(function(jqXHR, status, error) {
                switch (jqXHR.status) {
                    case 503:
                        aj.notify_message({
                            message: aj.maintenanceMessage,
                            extra_tags: 'error'
                        });
                        break;
                    default:
                        console.log(jqXHR.status);
                        aj.notify_message({
                            message: aj.errorMessage,
                            extra_tags: 'error'
                        });
                        break;
                }
            }).always(function() {
                t.lock(false);
            });
        };
    };
    return t;
})(tindie.messaging || {}, jQuery);
